/**
 * Turns `/url/path/` into `url-kebab`
 *
 * @param window window element
 * @example
 *  /en_US/this/that/ => this-that
 *  /es-us/foo/bar-baz => foo-bar-baz
 *  /this//that/the-other/ => this-that-the-other
 */
export const urlKebab = (window) => {
    const locale = new RegExp(/\b([\w]{2})[-|_]([\w]{2})\b/);

    return new URL(window.location).pathname
        .split('/')                        // Split on slashes
        .filter(part => part)               // Don't inlcude empty parts
        .filter(part => !locale.test(part)) // no locales
        .join('-');                        // Kebab-ify
};
